import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { CommonModule } from '@angular/common';
import { AuditTrailSearchService } from './audit-trail-search.service';

@Component({
  selector: 'dl-audit-trail-search',
   standalone: true,
  imports: [OneWebComponentsAngularModule,FormsModule,CommonModule],
  templateUrl: './audit-trail-search.component.html',
  styleUrl: './audit-trail-search.component.scss'
})
export class AuditTrailSearchComponent {
  public constructor(private auditTrailSearchService: AuditTrailSearchService) { }

  public searchValue: string = '';

  public ngOnInit(): void {}

  public applyFilter(filterValue: string): void {
    this.auditTrailSearchService.getSearchedData((filterValue || '').trim().toLocaleLowerCase());
  }

  public clearSearch(): void {
    this.searchValue = '';
    this.applyFilter('');
  }
}
